import type { AddOn } from './add-on';

export const hasPriceTiers = (addOn: AddOn | undefined): addOn is AddOn => Boolean(addOn?.priceTiers.length);

const getTierMin = (tier: { tierMin: number }): number => {
  if (tier.tierMin == null) {
    return 0;
  }

  const tierMin = Number(tier.tierMin);

  return Number.isFinite(tierMin) ? tierMin : Number.POSITIVE_INFINITY;
};

const sortTiersByTierMin = <tierType extends { tierMin: number }>(tiers: tierType[]): tierType[] =>
  [...tiers].sort((leftTier, rightTier) => getTierMin(leftTier) - getTierMin(rightTier));

export const getStartingPriceFromAddOn = (addOn: AddOn): number => {
  const sortedTiers = sortTiersByTierMin(addOn.priceTiers);

  if (!sortedTiers.length) {
    return 0;
  }

  const lowestTierMin = getTierMin(sortedTiers[0]);
  const tiersAtLowestTierMin = sortedTiers.filter((tier) => getTierMin(tier) === lowestTierMin);

  const firstPaidTierAtLowestTierMin = tiersAtLowestTierMin.find((tier) => tier.price.priceAmount > 0);

  if (firstPaidTierAtLowestTierMin) {
    return firstPaidTierAtLowestTierMin.price.priceAmount;
  }

  // Lowest volume tier is free (e.g. premium-included). Do not fall through to higher tiers.
  return tiersAtLowestTierMin[0].price.priceAmount;
};
